<template>
  <code style="word-spacing: 1px;">{{ identifier.toUpperCase() | regexGroups(/(...)(...)/) }}</code>
</template>

<script>
export default {
  props: ['identifier'],
};
</script>
